'use strict';

exports.__esModule = true;
exports.STATUS_CODE = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = statusCodeAction;

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var STATUS_CODE = exports.STATUS_CODE = 'status-code';
function statusCodeAction(statusCode) {
    if (typeof statusCode !== 'undefined' && statusCode !== null) {
        (0, _invariant2.default)(typeof statusCode === 'number', 'statusCode expects a number.');
    }

    return {
        name: STATUS_CODE,

        staticMethod: function staticMethod(_ref) {
            var httpResponse = _ref.httpResponse;

            httpResponse.statusCode = statusCode || httpResponse.statusCode;
        },

        initServerAction: function initServerAction(params) {
            var httpResponse = params.httpResponse || {};
            return {
                httpResponse: (0, _extends3.default)({
                    statusCode: 200
                }, httpResponse)
            };
        },

        filterParamsToProps: function filterParamsToProps(_ref2) {
            var httpResponse = _ref2.httpResponse;

            return { httpResponse: httpResponse };
        }
    };
}